export const StatusTypes = [
  // { label: "Communication Chain", value: "communication_chain" },
  { label: "Outgoing", value: "outgoing" },
  { label: "Incoming", value: "incoming" },
  { label: "Question", value: "question" },
  { label: "IFA", value: "ifa" },
  { label: "IFF", value: "iff" },
];
